import { createFileRoute } from '@tanstack/react-router';
import { AiChatPage } from '@/pages/ai-assistant';

export const Route = createFileRoute('/_protected/ai-chat/chat/')({
  component: AiChatPage,
});
